export default __webpack_public_path__ + "static/media/00594182-0848-4C5F-A2A3-694CEB65A5F9_1_201_a.9c3d61cf.jpeg";